<template>
  <div class="dashboard">
    <h3 class="widget-title">PBX Details</h3>
    <div class="d-flex info-widgets-container mt-3">
      <div class="chart-container big">
        <LineChart chartTitle="Call Distribution" :stats="callDistribution" />
        <half-circle-spinner
          :animation-duration="1500"
          :size="50"
          color="#94c120"
          class="spinner"
          v-if="loading.callDistribution"
        />
      </div>
      <div class="chart-container small">
        <PieChart
          chartTitle="Total answered calls / Day"
          :stats="answeredCalls"
        />
        <half-circle-spinner
          :animation-duration="1500"
          :size="50"
          color="#94c120"
          class="spinner"
          v-if="loading.answeredCalls"
        />
        <h6
          class="chart-no_data_msg"
          v-if="answeredCalls && !answeredCalls.values.length"
        >
          No data available
        </h6>
      </div>
      <div class="chart-container small">
        <PieChart chartTitle="Total Extensions" :stats="totalExtensions" />
        <half-circle-spinner
          :animation-duration="1500"
          :size="50"
          color="#94c120"
          class="spinner"
          v-if="loading.allExtensions"
        />
        <h6
          class="chart-no_data_msg"
          v-if="totalExtensions && !totalExtensions.values.length"
        >
          No data available
        </h6>
      </div>
      <div class="chart-container big">
        <LineChart chartTitle="Total Voicemails / Month" :stats="voiceMails" />
        <half-circle-spinner
          :animation-duration="1500"
          :size="50"
          color="#94c120"
          class="spinner"
          v-if="loading.voiceMails"
        />
      </div>
      <!-- <div class="chart-container small">
        <DonutChart chartTitle="Time spent on status “Offline” / Month" />
      </div>
      <div class="chart-container small">
        <DonutChart chartTitle="Time spent on status “Online” / Month" />
      </div> -->
    </div>
    <h3 class="widget-title">Service Level Details</h3>
    <div class="d-flex info-widgets-container">
      <half-circle-spinner
        :animation-duration="1500"
        :size="50"
        color="#94c120"
        class="mx-5 my-5"
        v-if="loading.averageDuration"
      />
      <InfoWidget
        v-if="averageDuration"
        image="call_duration"
        titleSmall="Average call duration /month"
        :value="averageDuration.average"
        :info="`Based on ${averageDuration.calls} calls`"
        titleLarge="Average call duration"
        theme="light"
      />
      <!-- <InfoWidget
        v-if="averageDuration"
        image="hold_time"
        titleSmall="Average Hold time"
        :value="averageDuration.average"
        titleLarge="Average Hold time"
        :info="'Based on 333 calls'"
        theme="light"
      />
      <InfoWidget
        v-if="averageDuration"
        image="waiting_time"
        titleSmall="Average waiting time on queue"
        :value="averageDuration.average"
        titleLarge="Average waiting time on queue"
        :info="'Based on 333 calls'"
        theme="light"
      /> -->
    </div>
    <h3 class="widget-title">Billing Details</h3>
    <div class="d-flex info-widgets-container">
      <InfoWidget
        v-if="balance && !balanceError"
        image="balance"
        titleSmall="Balance"
        :value="balance"
        linkText="Refill Balance"
        linkPath="#"
        theme="light"
        :loading="loading.balance"
        :popup="true"
      />
      <InfoWidget
        v-if="!loading.balance && balanceError"
        image="balance"
        titleSmall="Balance"
        :value="{
          amount: '-',
          currency: ''
        }"
        theme="light"
        :error="true"
        info="Check your Integration"
        :loading="loading.balance"
        :popup="true"
      />
      <InfoWidget
        v-if="usage && !usageError"
        image="usage"
        :titleSmall="`Last ${usage.days} days usage`"
        :value="{
          amount: usage.amount,
          currency: usage.currency
        }"
        :titleLarge="`Last ${usage.days} days usage`"
        theme="light"
        :loading="loading.usage"
      />
      <InfoWidget
        v-if="!loading.usage && usageError"
        image="usage"
        :titleSmall="`Usage`"
        :value="{
          amount: '-',
          currency: ''
        }"
        theme="light"
        :error="true"
        info="Check your Integration"
        :loading="loading.usage"
      />
      <!-- <InfoWidget
        v-if="overdueInvoices && !invoicesError"
        image="invoice"
        titleSmall="Total amount of overdue invoices"
        :value="{
          amount: overdueInvoices.totalAmount,
          currency: overdueInvoices.currency
        }"
        :titleLarge="`Total overdue invoices: ${overdueInvoices.invoicesCount}`"
        info="Overdue invoices for Innocalls"
        theme="dark"
      /> -->
      <!-- <InfoWidget
        v-if="!loading.overdueInvoices && invoicesError"
        image="invoice"
        titleSmall="Total amount of overdue invoices"
        :value="{
          amount: '-',
          currency: ''
        }"
        info="Check your Integration"
        :error="true"
        theme="dark"
      />
      <half-circle-spinner
        :animation-duration="1500"
        :size="50"
        color="#94c120"
        class="mx-5 my-5"
        v-if="loading.balance || loading.usage || loading.overdueInvoices"
      /> -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import InfoWidget from './components/InfoWidget'
import LineChart from './components/LineChartWidget'
import PieChart from './components/PieChartWidget'
// import DonutChart from './components/DonutChartWidget'
import HalfCircleSpinner from 'epic-spinners/src/components/lib/HalfCircleSpinner'

export default {
  name: 'dashboard',
  components: {
    InfoWidget,
    LineChart,
    PieChart,
    // DonutChart,
    HalfCircleSpinner
  },
  data() {
    return {
      loading: {},
      totalExtensions: undefined,
      balanceError: false,
      usageError: false,
      invoicesError: false
    }
  },
  computed: {
    ...mapGetters([
      'currentAccount',
      'usage',
      'balance',
      'callDistribution',
      'answeredCalls',
      'voiceMails',
      'averageDuration',
      // 'overdueInvoices',
      'allExtensions',
      'integrationError'
    ])
  },
  methods: {
    ...mapActions([
      'fetchUsage',
      'fetchBalance',
      'fetchCallDistribution',
      'fetchAnsweredCalls',
      'fetchVoiceMails',
      'fetchAverageDuration',
      // 'fetchOverdueInvoices',
      'fetchAllExtensions'
    ]),
    fetchDashboardStats() {
      if (!this.callDistribution) {
        this.loading.callDistribution = true
        this.fetchCallDistribution()
      }
      if (!this.answeredCalls) {
        this.loading.answeredCalls = true
        this.fetchAnsweredCalls()
      }
      if (!this.voiceMails) {
        this.loading.voiceMails = true
        this.fetchVoiceMails()
      }
      if (!this.averageDuration) {
        this.loading.averageDuration = true
        this.fetchAverageDuration()
      }
      if (!this.usage) {
        this.loading.usage = true
        this.fetchUsage()
      }
      if (!this.balance) {
        this.loading.balance = true
        this.fetchBalance()
      }
      // if (!this.overdueInvoices) {
      //   this.loading.overdueInvoices = true
      //   this.fetchOverdueInvoices()
      // }
      if (!this.allExtensions.length) {
        this.loading.allExtensions = true
        this.fetchAllExtensions()
      }
    }
  },
  watch: {
    currentAccount() {
      this.fetchCallDistribution()
      this.fetchAnsweredCalls()
      this.fetchVoiceMails()
      this.fetchAverageDuration()
      this.fetchUsage()
      this.fetchBalance()
      // this.fetchOverdueInvoices()
      this.fetchAllExtensions()
      this.loading = {
        callDistribution: true,
        answeredCalls: true,
        voiceMails: true,
        averageDuration: true,
        usage: true,
        balance: true,
        overdueInvoices: true
      }
    },
    callDistribution(val) {
      if (val) {
        this.loading.callDistribution = false
      }
    },
    voiceMails(val) {
      if (val) {
        this.loading.voiceMails = false
      }
    },
    answeredCalls(val) {
      if (val) {
        this.loading.answeredCalls = false
      }
    },
    averageDuration(val) {
      if (val) {
        this.loading.averageDuration = false
      }
    },
    usage: {
      immediate: true,
      handler(val) {
        if (val) {
          this.loading.usage = false
          if (val.error) {
            this.$store.commit('setIntegrationError', true)
            this.usageError = true
          } else {
            this.$store.commit('setIntegrationError', false)
            this.usageError = false
          }
        }
      }
    },
    balance: {
      immediate: true,
      handler(val) {
        if (val) {
          this.loading.balance = false
          if (val.error) {
            this.$store.commit('setIntegrationError', true)
            this.balanceError = true
          } else {
            this.$store.commit('setIntegrationError', false)
            this.balanceError = false
          }
        }
      }
    },
    overdueInvoices: {
      immediate: true,
      handler(val) {
        if (val) {
          this.loading.overdueInvoices = false
          if (val.error) {
            this.$store.commit('setIntegrationError', true)
            this.invoicesError = true
          } else {
            this.$store.commit('setIntegrationError', false)
            this.invoicesError = false
          }
        }
      }
    },
    allExtensions: {
      immediate: true,
      handler(val) {
        if (val.length) {
          this.totalExtensions = {
            labels: [`Extensions ${val.length}`],
            values: [val.length]
          }
        } else {
          this.totalExtensions = {
            labels: [],
            values: []
          }
        }
        this.loading.allExtensions = false
      }
    },
    integrationError: function(val) {
      if (val) {
        this.$toasted.show('Check your integration', {
          icon: 'fa-times-circle',
          position: 'top-right',
          duration: 0,
          fullWidth: false,
          theme: 'error'
        })
      }
    }
  },
  created() {
    this.fetchDashboardStats()
  }
}
</script>
<style lang="scss">
.info-widgets-container {
  flex-wrap: wrap;
  .chart-container {
    margin-right: 1%;
    position: relative;
    .spinner,
    .chart-no_data_msg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 9999;
    }
    &.big {
      flex-basis: 48%;
      min-width: 600px;
    }
    &.small {
      flex-basis: 23%;
      min-width: 300px;
    }
  }
}
h3.widget-title {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  text-decoration: underline;
}
.vuestic-chart {
  max-height: 300px !important;
  height: 300px !important;
  width: 100%;
}
.vuestic-widget.chart-widget {
  position: relative;
  .vuestic-widget-header {
    background-color: $blue;
    color: $white !important;
    text-align: center;
    justify-content: center;
    border-top-right-radius: $widget-border-radius;
    border-top-left-radius: $widget-border-radius;
    font-size: 1.1rem;
  }
}
@media (max-width: 768px) {
  .info-widgets-container {
    .chart-container {
      &.big {
        min-width: 100%;
      }
      &.small {
        min-width: 49%;
      }
    }
  }
}
@media (max-width: 475px) {
  .info-widgets-container {
    .chart-container {
      &.small {
        min-width: 100%;
      }
    }
  }
}
</style>
